import {
    Typography,
    Box,
    Stack,
} from "@mui/material";
import { useState, useEffect } from 'react';
import React from 'react';
import MockData from "../../helper/MockData";
import { useNavigate } from "react-router-dom";
import { InfoApi } from "../../api/InfoApi";
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";


import SkillSelectionList from "../../components/app/SkillSelectionList";


function getFilteredSkills(skillList, availableSkillCodes) {
    if (!availableSkillCodes || availableSkillCodes.length === 0) {
        return skillList;
    }
    // console.debug("availableSkillCodes: ", availableSkillCodes);


    const filteredSkills = skillList.filter(skill => availableSkillCodes.includes(skill.code));
    // console.debug("filteredSkills: ", filteredSkills);
    return filteredSkills;
}

export default function SkillSelectionSection({ event }) {
    const [skillList, setSkillList] = useState(null);
    const { t } = useTranslation();
    const navigate = useNavigate();

    let lang = getLang();

    useEffect(() => {
        loadData();
    }, []);

    console.debug("availableSkill: ", event.leaderboard_skill_setting);
    console.debug("event: ", event);


    const loadData = async () => {
        // console.debug("currentMemberID: ", currentMemberID);
        const result = await InfoApi.getSkillList();
        // console.debug("result: ", result);
        // setSkillList(result);
        const availableSkillList = getFilteredSkills(result, event.leaderboard_skill_setting);

        console.debug("availableSkillList: ", availableSkillList);
        setSkillList(availableSkillList);
    };

    const onSelectSkill = (skill) => {
        console.debug("skill=", skill);

        const options = {
            state: { skill, event }
        };
        navigate(`/skill-input/${skill.code}`, options);
    }


    return (
        <Stack>{
            (
                skillList ?
                    <SkillSelectionList skillList={skillList} onSelect={onSelectSkill} />
                    :
                    <Box>Loading...</Box>
            )


            // <pre>
            //     {JSON.stringify(skillList, null, 2) }
            // </pre>
        }
            <pre>
                {/* Event: {JSON.stringify(event, null, 2)}

                SkillList:
                {JSON.stringify(skillList, null, 2)} */}
            </pre>
        </Stack>
    )
}
